// extracted by mini-css-extract-plugin
module.exports = {"root":"Mentors_root__3qcjs","title":"Mentors_title__uDJ7E","list":"Mentors_list__3sS2g"};